export default __webpack_public_path__ + "static/media/59-min.26590a42.jpg";